import "./App.scss";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Authorization from "./Authorization/Authorization";
import GameLayout from "./layouts/GameLayout/GameLayout";
import { Toaster } from "react-hot-toast";
import PlayGame from "./PlayGame/PlayGame";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./App/store";
import Spinner from "./components/shared/Spinner/Spinner";
import { useEffect, useMemo, useState } from "react";
import Popup from "./components/shared/Popup/Popup";
import { closePopup, openPopup } from "./App/Slices/popupSlice";
import { changeStatus } from "./App/Slices/gameSlice";
import OverGame from "./OverGame/OverGame";
import Overlay from "./components/shared/Overlay/Overlay";
import { Profile } from "./Profile/Profile";

function App() {
  const userSelector = useSelector((state: RootState) => state.user);
  const gameSelector = useSelector((state: RootState) => state.game);
  const dispatch = useDispatch();

  const [showGame, setShowGame] = useState<boolean>(false);

  useEffect(() => {
    switch (gameSelector.status) {
      case "play":
      case "start":
        setShowGame(true);
        break;
      default:
        setShowGame(false);
        break;
    }
  }, [gameSelector.status]);

  useMemo(() => {
    window.addEventListener(
      "ErrorEvent",
      function (evt: any) {
        console.log("event :", evt.message, JSON.stringify(evt.message || {}));
        dispatch(
          openPopup(
            <Spinner
              color="red"
              renderContent="Something went wrong. Please try again later."
            ></Spinner>
          )
        );
        setTimeout(() => {
          dispatch(closePopup(""));
          dispatch(changeStatus("stateless"));
          window.location.reload();
          // (window as any).quitGame();
        }, 5000);
      },
      false
    );
  }, []);

  return (
    <>
      <div className={!showGame ? "FullScreen" : "BackScreen"}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<GameLayout />}>
              <Route
                path="authorization"
                element={
                  userSelector?.wallet && userSelector?.user?._id ? (
                    <Navigate to={"/"}></Navigate>
                  ) : (
                    <Authorization />
                  )
                }
              />
              <Route index element={<PlayGame />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Routes>
          <Overlay />
        </BrowserRouter>
      </div>
      <Popup />

      <Toaster containerClassName="toaster"/>
      {gameSelector.status == "play" ? <OverGame /> : ""}

      <div className={`Loader ${showGame ? "FullScreen" : "BackScreen"}`}>
        <div className="Loader__spinner">
          <Spinner size={3.7} color="red"></Spinner>
        </div>
      </div>
    </>
  );
}

export default App;
